import api from './client';

// تنظیمات عمومی سایت (اینماد، تماس، درگاه) — با کش درون-حافظه‌ای ۱۰ دقیقه
let cache = null;
let expiresAt = 0;

export async function getSiteSettings(force = false) {
  const now = Date.now();
  if (!force && cache && now < expiresAt) {
    return cache;
  }
  try {
    const res = await api.get('users/site-settings/public/');
    cache = res.data;
    expiresAt = now + 10 * 60 * 1000;
    return cache;
  } catch (e) {
    // در صورت خطا، آخرین مقدار موفق (یا null) برمی‌گردد؛ مصرف‌کننده مقدار پیش‌فرض خودش را دارد
    return cache;
  }
}
